<template>
    <div>
        
        <!-- <h1>{{$t('userInfo.name')}}</h1> -->
        <!--顶部导航-->
        <navgate></navgate>
        <!--内容区域-->
        <div class="web_box">
            <div class="web_content">
                <div class="layout_box">
                    <RowSlider selectedKey="partyRules" parentRouteKey="partyBuild"></RowSlider>
                    <div class="layout_right">
                        <TitleListView2 titleName="章程和相关制度" :messageList="rulesList.list" :perPage="perPage" detailRouter="cccc"></TitleListView2>
                    </div>
                    
                </div>
            </div>
            <!--联系我们-->
            <footer-build></footer-build>
        </div>
        <!--<button @click="changLang">ccccc</button>-->
        <router-view/>
    </div>
    
</template>

<script>
import store from '../../store' 
import RowSlider from './childSlider/RowSlider'
import TitleListView2 from './container/TitleListView2'
import HttpUtils from "../../util/HttpUtils";
export default {
  name: 'partyRules',
  components:{TitleListView2,RowSlider},
  props: {
    
  },
  data(){
    return{
      rulesList:{total:0,perPage:1,list:[]},
      perPage:1,
    }
  },
  methods:{
    loadNewsData(){
      // this.rulesList = require('../../store/json/partyRules.json')
      // this.perPage = this.rulesList.perPage;
      let that = this;
      new HttpUtils().sendGet(that, '/foundation_api/partyRules.json',  { }, function (sucess, res) {
        that.rulesList = res
        that.perPage = that.rulesList.perPage;
      });
    },
    secondItemClick(pageName){
      this.$router.push(pageName)
    },
    changLang(){
      const lang = this.$i18n.locale //获取当前页面默认使用的语言
      console.log(lang)  //控制台输出 'zh'
      // 实现中英切换
      if(lang == 'zh'){ //如果默认是中文，在用户点击时就切换到英文状态
          this.$i18n.locale = 'en'
      }else {
          this.$i18n.locale = 'zh'
      }
    }
  },
  mounted(){
    this.loadNewsData();
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"> 
    @import '../../assets/css/ks_foundation.less';
    @import '../../assets/css/ks_media.less';
    @import '../../assets/fonts/iconfont.css';
</style>
